import { makeCrud } from "./crud";

const crud = makeCrud("services");

export const fetchServices = (filters, signal) => crud.list(filters, signal);
export const fetchService = crud.get;
export const createService = crud.create;
export const updateService = crud.update;
export const deleteService = crud.remove;
